import React from 'react';
import s from './solutions-grid.scss';
import { SolutionGridWrapper } from '../../../solution-grid-wrapper/solution-grid-wrapper';
// import { ISolutionGridProps } from "@wix/app-market-collection-widget/dist/src/components/solution/solution-grid";
import { composer } from '../../../../component-decorators/composer';
import { Card, Heading } from 'wix-style-react';
export var SolutionsGrid = composer()
    .withTranslation()
    .compose(function (props) {
    return (React.createElement(Card, { className: s.suggestionsSection },
        React.createElement(Heading, { appearance: 'H2', className: s.suggestionsTitle, dataHook: 'solutions-grid-title' }, props.t('solution.page.YouMayAlsoLike')),
        React.createElement(SolutionGridWrapper, { solutions: props.solutions, isCompany: true, colSpan: 4, isFull: true, referralSectionName: props.referralSectionName ? props.referralSectionName : "may-also-like", collimp_id: props.collimp_id, referralInfo: props.referralInfo })));
});
//# sourceMappingURL=solutions-grid.js.map